import { Component, OnInit } from '@angular/core';
import { TeamSlider, TestimonialSlider } from '../../shared/data/slider';

@Component({
  selector: 'app-award', 
  templateUrl: './award.component.html'
})
export class AwardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  public TeamSliderConfig: any = TeamSlider;
  public TestimonialSliderConfig: any = TestimonialSlider;


    public sliders = [{
    title: 'ANDROID APP DEVELOPMENT    ',
    subTitle: 'Welcome to Aquila , a leading provider of cutting-edge Android app development solutions. Founded with a passion for innovation and a commitment to excellence, we strive to empower businesses and individuals with transformative mobile experiences that drive success in the digital world. ',
    image: 'assets/images/slider/1.jpg'
  }];
  // Testimonial Carousel
  public testimonial = [{
    image: 'assets/images/testimonial/1.jpg',
    name: 'Mark jkcno',
    designation: 'Designer',
    description: 'you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.',
  }, {
    image: 'assets/images/testimonial/2.jpg',
    name: 'Adegoke Yusuff',
    designation: 'Content Writer',
    description: 'you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.',
  }, {
    image: 'assets/images/testimonial/1.jpg',
    name: 'John Shipmen',
    designation: 'Lead Developer',
    description: 'you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.',
  }]

   // Blog
   public blogs = [{
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-coding-software-developer-work-augmented-reality-dashboard-computer-icons-scrum.jpg',
    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',
    date: 'March 30, 2024',
    title: 'Unleashing Creativity with Android Development: Building Innovative Mobile Experiences,',
    by: 'John Dio'
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-website-designer-working-with-the-new-computer-interface-as-desi.jpg',

    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',

    date: 'March 30, 2024',
    title: 'Elevate Your Travel Experience with Our Hotel Booking System    ',
    by: 'John Dio'
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-website-designer-working-with-the-new-computer-interface-as-desi.jpg',
    date: 'March 30, 2024',
    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',
   
    title: 'The Role of Artificial Intelligence in Modern Business Solutions    ',
    by: 'John Dio'
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-programmer-working-software-development-coding-technologies-website-design-technology-concept.jpg',
    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',
    date: 'March 30, 2024',
    title: 'Elevate Your Online Presence with Professional Web Development Services',
    by: 'John Dio'
  }]

  // Team 
  public team = [{
    image: 'assets/images/team/1.jpg',
    name: 'Mark jkcno',
    designation: 'Designer'
  }, {
    image: 'assets/images/team/2.jpg',
    name: 'Adegoke Yusuff',
    designation: 'Content Writer'
  }, {
    image: 'assets/images/team/3.jpg',
    name: 'John Shipmen',
    designation: 'Lead Developer'
  }, {
    image: 'assets/images/team/4.jpg',
    name: 'Hileri Keol',
    designation: 'CEO & Founder at Company'
  }, {
    image: 'assets/images/team/3.jpg',
    name: 'John Shipmen',
    designation: 'Lead Developer'
 }]

}
